/**
 * 申请试用弹窗流程：协议确认 → 签署 → 申请 → 成功提示
 * 模板需放置 TrialAgreementDialog、TrialSuccessDialog
 */
import TrialAgreementDialog from './TrialAgreementDialog.vue';
import TrialSuccessDialog from './TrialSuccessDialog.vue';
import {
  subscriptionState,
  signAgreement,
  applySubscriptionTrial,
  AGREEMENT_TYPE_TRIAL,
} from './subscriptionService';
import { refreshIndivSession } from '../indivSession/indivSessionService';

export default {
  components: {
    TrialAgreementDialog,
    TrialSuccessDialog,
  },

  data() {
    return {
      showTrialAgreementDialog: false,
      showTrialSuccessDialog: false,
      successTrialDays: 14,
      trialClaiming: false,
    };
  },

  methods: {
    /** 打开试用协议弹窗（与账户页横幅「立即领取」一致） */
    openTrialApplyDialog() {
      if (this.trialClaiming) {
        return;
      }
      this.showTrialAgreementDialog = true;
    },

    /** 同意协议后签署并申请试用 */
    onTrialAgreementAgree() {
      if (this.trialClaiming) {
        return;
      }

      this.trialClaiming = true;
      signAgreement(AGREEMENT_TYPE_TRIAL)
        .then((signResult) => {
          const agreementId =
            signResult && signResult.agreementId != null
              ? signResult.agreementId
              : null;
          if (!agreementId) {
            throw new Error('协议签署失败');
          }
          return applySubscriptionTrial(agreementId);
        })
        .then((applyResult) => {
          this.showTrialAgreementDialog = false;
          this.successTrialDays =
            applyResult && applyResult.trialDays != null
              ? Number(applyResult.trialDays)
              : subscriptionState.trialDays || 14;
          this.showTrialSuccessDialog = true;
          return refreshIndivSession({
            force: true,
            store: this.$store,
          });
        })
        .catch((err) => {
          this.$message.error(
            (err && err.message) || '网络异常，请稍后重试'
          );
        })
        .finally(() => {
          this.trialClaiming = false;
        });
    },

    /** 试用开通成功弹窗关闭 */
    onTrialSuccessConfirm() {
      if (typeof this.onTrialApplied === 'function') {
        this.onTrialApplied();
      }
    },

    /** 试用成功弹窗内「去实名」 */
    onTrialSuccessOpenRealname() {
      this.showTrialSuccessDialog = false;
      this.openRealnameDialog();
    },

    /** 试用成功弹窗内「购买服务」→ 打开选套餐弹窗 */
    onTrialSuccessPurchase() {
      this.showTrialSuccessDialog = false;
      if (typeof this.openPurchaseDialog === 'function') {
        this.openPurchaseDialog(subscriptionState.status);
        return;
      }
      this.$emit('purchase');
    },
  },
};



// WEBPACK FOOTER //
// ./src/view/user/subscriptionService/subscriptionTrialApplyMixin.js